export default [
  /** 推荐好友 开始 */
  {
    path: '/invite/index',
    name: 'inviteRigister',
    component: () => import(/* webpackChunkName: "inviteRigister" */ '../../views/invite/Index.vue'),
    meta: {
      title: '邀请好友',
    },
  },
  {
    path: '/invite/haibao',
    name: 'haibao',
    component: () => import(/* webpackChunkName: "haibao" */ '../../views/invite/HaiBao.vue'),
    meta: {
      title: '邀请海报',
    },
  },
  {
    path: '/invite/qrcode',
    name: 'qrcode',
    component: () => import(/* webpackChunkName: "qrcode" */ '../../views/invite/Qrcode.vue'),
    meta: {
      title: '邀请二维码',
    },
  },
  {
    path: '/invite/rigister',
    name: 'Rigister',
    component: () => import(/* webpackChunkName: "rigister" */ '../../views/invite/Rigister.vue'),
    meta: {
      title: '推荐注册',
    },
  },

  /** 推荐好友 结束 */
]
